// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"6a24a923","421":"3c358850","453":"d4ff5ebf","493":"16233b72","503":"bd30ca08","582":"32cf98ea","683":"b92ba31e","693":"0c228358","768":"ddda72ae","962":"9aa7c9c9"}[chunkId] + ".chunk.js";
};